//basic-card
export const basicCardSubTitle = [{ text: 'This is a simple basic card using anywhere.' }];

export const flatCardSubTitle = [
    {
        text: 'For flat cards, make the',
        code: '.b-r-0[border-radius:0] '
    },
    {
        text: 'used class.'
    }
];

export const withoutShadowSubTitle = [
    {
        text: 'Use the',
        code: '.shadow-none '
    },
    {
        text: '&',
        code: '.border '
    },
    {
        text: 'class through shadow removes.'
    }
];

export const darkCardSubTitle = [
    {
        text: 'Use the ',
        code: ' .bg-dark '
    },
    {
        text: 'color for dark background card.'
    }
]

//creative-card
export const borderLeftSubTitle = [
    {
        text: 'Use the class of',
        code: '.b-l-* '
    },
    {
        text: 'for left border.'
    }
];

export const borderRightSubTitle = [
    {
        text: 'Use the class of',
        code: '.b-r-* '
    },
    {
        text: 'for right border.'
    }
];

export const borderTopSubTitle = [
    {
        text: 'Use the class of',
        code: '.b-t-* '
    },
    {
        text: 'for top border.'
    }
];

export const borderBottomSubTitle = [
    {
        text: 'Use the class of',
        code: '.b-b-* '
    },
    {
        text: 'for bottom border.'
    }
];

export const borderPrimarySubTitle = [
    {
        text: 'Use the class of',
        code: '.b-l-* '
    },
    {
        text: 'for left border and ',
        code: '.border-3 '
    },
    {
        text: 'is used to increase the width of the border.'
    }
];

export const borderSecondaryData = [
    {
        text: 'Stella Nowland',
        class: 'warning',
        text2: 'Freelance'
    },
    {
        text: 'Lola Stanford',
        class: 'danger text-white',
        text2: 'Issue'
    },
    {
        text: 'Caitlin Coungeau',
        class: 'primary text-white',
        text2: 'Social'
    },
    {
        text: 'Graciela McClaran',
        class: 'danger text-white',
        text2: 'Issue'
    }
]